// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "1fcc78fcd9bb041c2112" + ".chunk.js";
};